import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setContactLabours = (state, { contactLabours }) => {
  if (!contactLabours) return state;
  return state.merge({ contactLabours });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_CONTACT_LABOURS,
    actionFunction: setContactLabours,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
